// extracted by mini-css-extract-plugin
export default {"TeamPage":"TeamPage_TeamPage__d+0sU","TeamPageSpecialists":"TeamPage_TeamPageSpecialists__dKe9r"};